import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function Notification(props: Props) {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(styles.notification, {
        [styles.warning]: props.isWarning,
        [styles.success]: props.isSuccess,
      })}
    >
      <div className={styles.messages}>
        {props.messages.map((message, index) => (
          <p key={index} className={styles.message}>
            {message}
          </p>
        ))}
      </div>
      <div className={styles.button} onClick={props.close}>
        {t("appNotifications.close")}
      </div>
    </div>
  );
}

export { Notification };
